// Cost utility functions

export const generateCostCode = (costNumber: number): string => {
  const paddedNumber = String(costNumber).padStart(6, '0');
  const year = new Date().getFullYear();
  return `KS/${paddedNumber}/${year}`;
};

export const getNextCostNumber = (existingCosts: any[]): number => {
  if (existingCosts.length === 0) {
    return 1;
  }
  
  const lastCost = existingCosts[existingCosts.length - 1];
  const lastCode = lastCost.kodKos || lastCost.kod;
  
  // Parse the number from KS/XXXXXX/YYYY format
  const lastNumber = parseInt(lastCode.split('/')[1]);
  return lastNumber + 1;
};

export const COST_CATEGORIES = [
  'Bahan',
  'Tenaga Kerja',
  'Peralatan',
  'Transportasi',
  'Lainnya'
];

export const COST_UNITS = [
  'tin',
  'kg',
  'hari',
  'jam',
  'meter',
  'pcs',
  'box',
  'buah',
  'set'
];
